import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onReset }) => {
  return (
    <div className="text-center py-12 md:py-16 lg:py-20">
      <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 rounded-2xl bg-muted flex items-center justify-center">
        <Icon name="Search" size={40} className="opacity-50" />
      </div>

      <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
        Шаблоны не найдены
      </h3>

      <p className="text-sm md:text-base text-text-secondary mb-6 max-w-md mx-auto">
        Попробуйте изменить параметры фильтрации или сбросить все фильтры, чтобы увидеть все доступные шаблоны
      </p>

      <Button
        variant="default"
        iconName="RotateCcw"
        iconPosition="left"
        onClick={onReset}
      >
        Сбросить фильтры
      </Button>
    </div>
  );
};

export default EmptyState;